import { parseString } from 'dynamic-typing';

import add2D from './2d/add2D';
import { complexChromatogram } from './complexChromatogram';
import postProcessingNMR from './postProcessingNMR';
import profiling from './profiling';
import simpleChromatogram from './simpleChromatogram';

export default function postProcessing(entriesFlat, result, options) {
  // converting Hz to ppm
  postProcessingNMR(entriesFlat);

  createArray(entriesFlat, options);

  for (let entry of entriesFlat) {
    if (Object.keys(entry.ntuples).length > 0) {
      let newNtuples = [];
      let keys = Object.keys(entry.ntuples);
      for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        let values = entry.ntuples[key];
        for (let j = 0; j < values.length; j++) {
          if (!newNtuples[j]) newNtuples[j] = {};
          newNtuples[j][key] = values[j];
        }
      }
      entry.ntuples = newNtuples;
    }

    if (entry.twoD && options.wantXY) {
      add2D(entry, options);

      profiling(result, 'Finished countour plot calculation', options);

      if (!options.keepSpectra) {
        delete entry.spectra;
      }
    }

    // maybe it is a GC (HPLC) / MS. In this case we add a new format
    if (options.chromatogram) {
      if (entry.spectra.length > 1) {
        complexChromatogram(entry);
      } else {
        simpleChromatogram(entry);
      }
      profiling(result, 'Finished chromatogram calculation', options);
    }

    delete entry.tmp;
  }
}

function createArray(entriesFlat, options) {
  for (const entry of entriesFlat) {
    for (const key in entry.meta) {
      const value = entry.meta[key];
      if (typeof value === 'string') {
        if (value[0] === '{') {
          // could be an array
          if (value[value.length - 1] === '}') {
            const array = value
              .slice(1, -1)
              .split(/[,; ]+/)
              .filter((e) => e);
            for (let i = 0; i < array.length; i++) {
              entry.meta[key + String(i)] = options.dynamicTyping
                ? parseString(array[i])
                : array[i];
            }
          }
        } else if (value[0] === '(') {
          const lines = value.split(/\r?\n/);
          const regexp = /^\((?<from>\d+)\.\.(?<to>\d+)\)$/;
          if (regexp.test(lines[0])) {
            // parsing  '(0..63)'
            const [from, to] = lines[0].match(regexp).slice(1).map(Number);
            const array = lines
              .slice(1)
              .join(' ')
              .split(/[,; ]+/)
              .filter((e) => e);
            for (let i = from; i <= to; i++) {
              entry.meta[key + String(i)] = options.dynamicTyping
                ? parseString(array[i - from])
                : array[i - from];
            }
          }
        }
      }
    }
  }
}
